@import '../../shared';

rass-overlay,
:host {
  background-color: var(--sfc-body-color-background);
  display: none;
  overflow: auto;
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
}

rass-overlay.isActive,
:host(.isActive) {
  display: block;
  z-index: 1000;
}

.logo {
  display: none;
}

.pressure-cooker {
  max-width: 227px;
  width: 100%;
}

.not-found {
  max-width: 200px;
  width: 100%;
}

.smartphone-criminal {
  max-width: 227px;
  width: 100%;
}

@media (min-width: 576px) {
  .logo {
    display: block;
    height: 24px;
    width: 130px;
  }

  .pressure-cooker {
    max-width: 348px;
  }
  .smartphone-criminal {
    max-width: 348px;
  }
}
